import { graphql } from 'gatsby'
import React from 'react'
import QuoteBlock, {
  QuoteBlockContent,
} from 'src/components/organisms/general/quoteBlock'

// TEMP: Use any if typegen not yet run
// type Props = { slice: PrismicPageDataBodyQuoteBlock }
type Props = { slice: any }

const QuoteBlockSlice = ({ slice }: Props) => {
  const content: QuoteBlockContent = {
    anchor: slice.primary.anchor ?? undefined,
    quote: slice.primary.quoteBlockQuote?.richText?.[0]?.text ?? '',
    name: slice.primary.name ?? '',
    title: slice.primary.title ?? '',
  }
  return <QuoteBlock content={content} />
}

export default QuoteBlockSlice

export const fragmentQuery = graphql`
  fragment PageDataBodyQuoteBlock on PrismicPageDataBodyQuoteBlock {
    primary {
      anchor
      quoteBlockQuote: quote {
        richText
      }
      name
      title
      icon {
        url
        alt
      }
    }
  }
`
